import React from "react";
import { nanoid } from "nanoid";
import { useTranslation } from "react-i18next";

import { errorSvg } from "../../svgs";
import { NotificationBoxWrapper } from "./styled";

const Errors: React.FC<any> = ({ errorText, globalErrors, noMatch }) => {
  const { t } = useTranslation();
  return (
    <NotificationBoxWrapper
      // data={authError}
      className={`flex-column -error`}
    >
      {errorSvg()}
      <div>{errorText || t("fillFields")}</div>
      {/* <ul>
      {Object.keys(errors).map((keyName ) => (
        <li key={nanoid()}>{errors[keyName]?.message}</li>
      ))}
      {globalErrors.length ? globalErrors.map( el => (
        <li key={nanoid()}>{el}</li>
      )): null}
       {noMatch && <li>{t('passwordNotMatch')}</li>}
    </ul> */}
    </NotificationBoxWrapper>
  );
};
export default Errors;
